<script setup>
  import { defineProps, computed, inject } from 'vue'
  import { cssify } from '@/utilities';

  const isDarkMode = inject('isDarkMode')

  const props = defineProps({
    tool: String,
    description: String,
    disabled: Boolean
  });

  const toolUrl = computed(()=>{
    return cssify(props.tool);
  });

</script>

<template>
  <component
    :is="props.disabled ? 'div' : 'router-link'"
    :to="'/'+toolUrl"
    :class="[
      'tool-card hover-shadow group flex flex-col min-h-100 items-stretch',
      props.disabled ? 'disabled' : '',
    ]"
  >
    <div :class="[
      'bg-tool-'+toolUrl,
      'text-white font-display text-2xl p-4'
    ]">
      {{props.tool}}
    </div>
    <img
      :src="isDarkMode
        ? $router.options.base+'/images/tools/'+toolUrl+'-dark.jpg'
        : $router.options.base+'/images/tools/'+toolUrl+'.jpg'
      "
      class="w-full"
    >
    <div class="p-4 flex-grow flex gap-4 flex-col items-stretch ">
      <p class="flex-grow">{{props.description}}</p>
      <div>
        <div
          v-if="props.disabled"
          class="button bg-gray-500 text-white"
          >Coming Soon</div>
        <router-link
          v-else
          :to="'/'+toolUrl"
          :class="'button bg-tool-'+toolUrl+' text-white group-hover:opacity-75 shadow'">
          Go
        </router-link>
      </div>
    </div>
  </component>

</template>
